var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$vuetify.breakpoint.smAndUp ? 'py-7 px-7' : ''},[_c('video-detail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }